import { render, staticRenderFns } from "./SendingRules.vue?vue&type=template&id=4f1d646e&scoped=true&"
import script from "./SendingRules.vue?vue&type=script&lang=js&"
export * from "./SendingRules.vue?vue&type=script&lang=js&"
import style0 from "./SendingRules.vue?vue&type=style&index=0&id=4f1d646e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d646e",
  null
  
)

export default component.exports